const lib = {
    isLoaded: false,
    AsYouType: null,
    getCountryCallingCode: null,
    getExampleNumber: null,
    isSupportedCountry: null,
    parsePhoneNumber: null,
    examples: null,
};

export async function getLibPhoneNumber() {
    if (lib.isLoaded) {
        return lib;
    }

    /* eslint-disable object-curly-newline */
    const {
        AsYouType,
        getCountryCallingCode,
        getExampleNumber,
        isSupportedCountry,
        parsePhoneNumber,
    } = await import('libphonenumber-js/max');
    /* eslint-enable object-curly-newline */

    const examplesModule = await import('libphonenumber-js/mobile/examples');

    lib.AsYouType = AsYouType;
    lib.getCountryCallingCode = getCountryCallingCode;
    lib.getExampleNumber = getExampleNumber;
    lib.isSupportedCountry = isSupportedCountry;
    lib.parsePhoneNumber = parsePhoneNumber;
    lib.examples = examplesModule.default;
    lib.isLoaded = true;

    return lib;
}
